import { DOMSerializer } from "@tiptap/pm/model"

// The markdown serializer drops any node type that lacks a `renderMarkdown`
// handler. To keep Hudu's HTML-preservation nodes (div, iframe, accordion,
// etc.) lossless when exporting/round-tripping markdown, we serialize those
// nodes back to their canonical HTML using the editor schema. Markdown allows
// embedded HTML, and the parser reconstructs the nodes via their `parseHTML`
// rules on the way back in.
let cachedSchema = null

export function setMarkdownSchema(schema) {
  cachedSchema = schema
}

export function getMarkdownSchema() {
  return cachedSchema
}

function escapeAttributeValue(value) {
  return String(value)
    .replace(/&/g, "&amp;")
    .replace(/"/g, "&quot;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
}

// Build an HTML attribute string from a node/mark's JSON attrs. Values that are
// null, false, or empty strings are omitted. Used for inline marks where the
// mark boundary (open/close tags) is emitted around a placeholder.
export function attrsToHtmlAttributes(attrs = {}) {
  return Object.entries(attrs || {})
    .filter(([, value]) => value != null && value !== false && value !== "")
    .map(([key, value]) => ` ${key}="${escapeAttributeValue(value)}"`)
    .join("")
}

// Serialize a single block node (and its subtree) to an HTML string using the
// primed editor schema. Returns "" when no schema is available (SSR/tests
// without a document) or when the node cannot be reconstructed.
export function serializeNodeToHtml(nodeJson) {
  if (!cachedSchema || typeof document === "undefined") return ""

  try {
    const node = cachedSchema.nodeFromJSON(nodeJson)
    const serializer = DOMSerializer.fromSchema(cachedSchema)
    const container = document.createElement("div")
    container.appendChild(serializer.serializeNode(node))
    return container.innerHTML
  } catch {
    return ""
  }
}
